function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02879,0,0,1.01559,-10.1155,10.7599)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.81398,0,0,4.81398,15.409,13.5637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.957,13.144C81.159,5.612 74.125,2.657 66.881,1.372C51.714,-1.319 37.414,4.317 25.452,11.273C16.029,16.849 7.849,23.608 0.253,31.462C-0.378,32.115 0.216,33.184 1.542,32.534C2.964,31.836 7.347,28.077 13.13,24.138C18.751,20.308 24.451,16.942 28.464,15.32C38.719,11.177 48.146,6.166 63.467,9.611C75.718,12.297 82.716,23.873 81.488,35.316C80.684,42.803 76.549,48.614 73.442,52.445C73.456,52.434 73.369,52.529 73.29,52.635C68.936,58.468 76.381,63.443 75.658,68.032C75.546,68.631 75.132,70.006 75.983,70.032C76.517,70.048 79.303,67.666 80.292,66.852C83.303,63.968 85.165,62.071 87.25,58.694C91.344,51.955 94.184,44.206 94.313,36.079C94.443,27.804 91.876,19.535 86.957,13.144Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.81398,0,0,4.81398,15.409,13.5637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.427,43.58C28.436,43.569 29.666,42.072 29.677,42.059C32.852,37.959 30.331,34.286 28.463,30.782C27.645,29.25 27.49,28.143 27.453,26.767C27.421,25.603 27.233,25.307 27.075,25.162C26.697,24.817 26.164,25.035 25.83,25.254C24.966,25.882 23.914,26.539 22.993,27.439C19.891,30.468 17.591,33.305 15.523,36.633C11.463,43.278 8.751,50.958 8.645,58.983C8.515,67.044 11.018,74.895 15.764,81.285C20.508,87.67 27.964,91.852 35.305,93.208C50.8,96.068 65.013,90.781 76.848,83.87C80.783,81.572 86.048,78.235 90.453,74.873C96.348,70.374 100.706,66.052 100.947,65.449C101.455,64.179 100.203,63.499 99.079,64.379C91.392,70.392 83.295,75.926 74.574,79.957C62.755,85.421 50.316,87.433 37.762,84.438C26.396,81.727 17.797,70.229 22.765,53.197C23.493,50.703 25.484,47.302 28.427,43.58Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.81398,0,0,4.81398,15.409,13.5637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.28,77.139C48.898,80.568 59.509,77.56 60.818,77.163C63.902,76.488 69.939,73.663 69.997,72.489C70.221,67.88 66.817,66.884 65.58,64.475C64.522,62.414 64.688,59.593 64.359,59.255C63.577,58.453 60.216,61.279 60.023,63.913C59.975,64.562 59.46,67.633 57.132,69.55C56.313,70.224 48.944,73.456 41.633,70.385C35.972,68.007 32.814,61.639 34.229,55.272C35.853,47.966 42.314,42.717 46.484,39.846C53.413,35.075 61.358,32.509 62.292,32.073C62.9,31.79 62.674,30.945 62.048,31.021C60.623,31.193 52.171,32.971 44.669,37.268C38.013,41.08 31.79,46.911 29.138,54.706C25.733,64.722 30.047,73.846 39.28,77.139Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.81398,0,0,4.81398,15.409,13.5637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.253,30.713C43.074,28.218 42.838,25.126 48.316,23.72C51.924,22.794 57.517,23.905 62.972,25.244C64.895,25.715 67.662,26.475 70.165,27.076C72.723,27.69 74.911,28.164 75.098,28.228C75.805,28.468 75.906,29.098 75.169,29.607C74.778,29.876 71.218,31.647 68.086,36.288C65.483,40.143 62.519,45.389 58.962,46.718C56.379,47.682 54.665,46.389 53.929,45.931C53.222,45.49 51.608,44.444 52.86,43.809C53.525,43.471 59.154,43.056 65.638,35.982C68.842,32.488 70.055,31.22 70.88,29.687C69.607,29.199 62.235,26.156 56.569,26.25C47.872,26.396 46.556,30.322 45.45,31.03C44.78,31.458 44.438,31.008 44.253,30.713Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.004b8c2cd5c8ddf870479f221d18f60c.svg";
export { ForwardRef as ReactComponent };